<template lang="pug">
  HistoryDialog(ref="HistoryDialog" title="固定支払料金"
    :leftData="fixedPaymentRateHistoryList" :oldUpdateUser="oldUpdateUser" :newUpdateUser="newUpdateUser" @incrementPageCount="incrementHistoryTablePageCount"
    @selectLine="selectLine" @terminate="terminate" load-url="fixedPaymentRate/fetchFixedPaymentRateHistoryList" :targetId="targetId")
    template(v-slot:rightTop)
      HistoryTable(:diffArrayData="newRows")

    template(v-slot:rightBottom)
      HistoryTable(:diffArrayData="oldRows")

</template>

<script>
import HistoryDialog from "@/components/common/dialog/HistoryDialog";
import HistoryTable from "@/components/common/HistoryTable";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  components: {
    HistoryDialog,
    HistoryTable
  },
  data() {
    return {
      targetId: null
    };
  },
  computed: {
    ...mapGetters({
      fixedPaymentRateHistoryList: "fixedPaymentRate/fixedPaymentRateHistoryList",
      fixedPaymentRateHistoryDiff: "fixedPaymentRate/fixedPaymentRateHistoryDiff"
    }),
    newRows: {
      get() {
        return this.fixedPaymentRateHistoryDiff != null ? this.fixedPaymentRateHistoryDiff.newRows : null;
      }
    },
    oldRows: {
      get() {
        return this.fixedPaymentRateHistoryDiff != null ? this.fixedPaymentRateHistoryDiff.oldRows : null;
      }
    },
    oldUpdateUser: {
      get() {
        return this.fixedPaymentRateHistoryDiff != null
          ? this.fixedPaymentRateHistoryDiff.oldUpdateUser
          : null;
      }
    },
    newUpdateUser: {
      get() {
        return this.fixedPaymentRateHistoryDiff != null
          ? this.fixedPaymentRateHistoryDiff.newUpdateUser
          : null;
      }
    }
  },
  methods: {
    ...mapMutations({
      incrementHistoryTablePageCount: "fixedPaymentRate/incrementHistoryTablePageCount",
      clearHistoryTablePageCount: "fixedPaymentRate/clearHistoryTablePageCount"
    }),
    ...mapActions("fixedPaymentRate", {
      fetchFixedPaymentRateHistoryList: "fetchFixedPaymentRateHistoryList",
      fetchFixedPaymentRateDiff: "fetchFixedPaymentRateDiff",
      clearHistoryData: "clearHistoryData"
    }),
    openDialog(data) {
      this.clearHistoryTablePageCount();
      this.targetId = data.id;
      this.fetchFixedPaymentRateHistoryList(data.id).then(value => {
        this.$refs.HistoryDialog.initialize();
      });
      this.$refs.HistoryDialog.openDialog();
    },
    closeDialog() {
      this.$refs.HistoryDialog.closeDialog();
    },
    selectLine(data) {
      if (data) {
        this.fetchFixedPaymentRateDiff(data.id);
      }
    },
    terminate() {
      this.clearHistoryData();
    }
  }
};
</script>

<style scoped lang="stylus"></style>
